var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"customer-name"},[_c('IconBase',{staticClass:"icon icon--customer",attrs:{"icon-name":"personal-details"}}),_c('span',{staticClass:"name"},[_vm._v(_vm._s(_vm.displayName))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }